module.exports = __webpack_public_path__ + "static/media/notification-sound.38eb1062.wav";